import { inject, Injectable } from '@angular/core';
import { CfDialogService } from '@cf/shared/dialog';
import { IAppEvent, SchemaAppEventDetail } from '@cf/temp/services';
import { EventRejectTentativeModalComponent } from './event-reject-tentative-modal.component';

@Injectable({
  providedIn: 'root',
})
export class EventRejectTentativeService {
  #dialogService = inject(CfDialogService);

  openDialog(event: IAppEvent | SchemaAppEventDetail) {
    return this.#dialogService.open({
      content: EventRejectTentativeModalComponent,
      data: { event },
    });
  }
}
